import { Logger, QueryClient } from '@tanstack/react-query';

export const createTestQueryClient = ({ logger }: { logger?: Logger } = {}) =>
  new QueryClient({
    logger,
    defaultOptions: {
      queries: {
        cacheTime: Infinity,
        retry: false,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: false,
      },
    },
  });
